<template>
  <div class="office-detail-warp">
    <div class="title">{{companyDetailList.name}}</div>
    <div class="cont-warp">
      <div class="message-warp">
        <h3>办证室信息:</h3>
        <div class="title-messag">
          <div class="category">公证员</div>
          <div class="pic-warp">
            <div class="pic-w-inner" style="background-image:url('static/images/ex_pic17.jpg');"></div>
            <span class="name">{{companyDetailList.message.name}}</span>
            <br>
            <span class="number">{{companyDetailList.message.number}}</span>
          </div>
        </div>
        <div class="today-all-number">
          <h4>今日办证总量</h4>
          {{companyDetailList.message.allNum}}
        </div>
        <div class="today-finish-number">
          <h4>今日已办数量</h4>
          {{companyDetailList.message.finNum}}
        </div>
        <div class="canmar-warp" @click="fullScreen" :class="{active: fullScreenSwite}">
          <canmar></canmar>
        </div>
      </div>
      <div class="server-warp">
        <h3>业务办理中:</h3>
        <div class="server-list-warp">
          <detail-list :offDetailList="companyDetailList.list"></detail-list>
        </div>
      </div>
    </div>
    <a href="javascript:;" class="go-back" @click="goback(true)">&times;</a>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import canmar from '@/components/canmar'
  import detailList from '@/components/office-detail-list'
  export default {
    components: { canmar, detailList },
    props: [
    ],
    data () {
      return {
        fullScreenSwite: false
      }
    },
    computed: {
      ...mapGetters([
        'companyDetailList'
      ])
    },
    watch: {
    },
    methods: {
      ...mapActions([
        'AgetBack'
      ]),
      hoverCityOver () {
      },
      hoverCityOut (iner) {
      },
      back (swit) {
        this.AgetBack(swit)
      },
      goback (swit) {
        this.AgetBack(swit)
        window.history.back()
      },
      fullScreen () {
        if (this.fullScreenSwite === false) {
          this.fullScreenSwite = true
        } else {
          this.fullScreenSwite = false
        }
      }
    },
    created () {
      setTimeout(() => {
      }, 1000)
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss">
  @import '../assets/scss/variables';
  @import '../assets/scss/mixins';
  .office-detail-warp {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 900px;
    height: 700px;
    text-align: center;
    border-radius: 6px;
    border: 2px solid rgba(#5389d8, .9);
    background: rgba($brand, .9);
    .title {
      position: relative;
      padding: 30px 70px;
      display: inline-block;
      line-height: 100%;
      font-size: 20px;
      color: $white;
      background: rgba($white, .3);
      &:after {
        position: absolute;
        right: -80px;
        top: 0;
        width: 0;
        height: 0;
        border-top: 80px solid rgba($white, .3);
        border-right: 80px solid transparent;
        content: "";
      }
      &:before {
        position: absolute;
        left: -80px;
        top: 0;
        width: 0;
        height: 0;
        border-top: 80px solid rgba($white, .3);
        border-left: 80px solid transparent;
        content: "";
      }
    }
    .cont-warp {
      width: 100%;
      height: calc(100% - 80px);
      padding: 50px 35px 75px 35px;
      @include clearfix;
    }
    .message-warp {
      width: calc(40% - 10px);
      height: 100%;
      padding: 15px;
      border-radius: 6px;
      border: 1px solid $brand-blue;
      float: left;
      color: $white;
      h3 {
        margin: 0;
        line-height: 100%;
        text-align: left;
        font-weight: normal;
      }
    }
    .server-warp {
      width: calc(60% - 10px);
      height: 100%;
      padding: 15px;
      border-radius: 6px;
      border: 1px solid $brand-blue;
      float: right;
      color: $white;
      h3 {
        margin: 0;
        line-height: 100%;
        text-align: left;
        font-weight: normal;
      }
      .server-list-warp {
        width: 100%;
        height: calc(100% - 39px);
      }
    }
    .title-messag {
      width: 100%;
      height: 150px;
      margin-top: 15px;
      margin-bottom: 15px;
      .category {
        width: 100%;
        height: auto;
        padding: 10px 15px;
        line-height: 100%;
        text-align: left;
        font-size: 18px;
        background: rgba($gray-dark, .8);
      }
      .pic-warp {
        position: relative;
        width: 100%;
        height: calc(100% - 38px);
        padding-left: 100px;
        padding-right: 15px;
        background: rgba($gray-dark, .2);
        span {
          width: 100%;
          height: 50%;
          line-height: 56px;
          display: inline-block;
          font-size: 18px;
          text-align: left;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
        .name {
          color: $brand-green;
          border-bottom: 1px solid rgba($white, .2);
        }
      }
      .pic-w-inner {
        position: absolute;
        left: 10px;
        top: 0;
        bottom: 0;
        margin: auto;
        width: 75px;
        height: 75px;
        border-radius: 50%;
        border: 2px solid $white;
        background-size: cover;
      }
    }
    .today-all-number {
      width: calc(50% - 5px);
      height: 100px;
      float: left;
      font-size: 18px;
      font-weight: bold;
      background: rgba($gray-dark, .2);
      h4 {
        margin: 0 0 15px 0;
        padding-top: 10px;
        padding-bottom: 10px;
        background: rgba($gray-dark, .8);
      }
    }
    .today-finish-number {
      width: calc(50% - 5px);
      height: 100px;
      float: right;
      font-size: 18px;
      font-weight: bold;
      background: rgba($gray-dark, .2);
      h4 {
        margin: 0 0 15px 0;
        padding-top: 10px;
        padding-bottom: 10px;
        background: rgba($gray-dark, .8);
      }
    }
    .canmar-warp {
      position: relative;
      width: 100%;
      height: 140px;
      margin-top: 15px;
      float: left;
      border: 3px solid $white;
      &.active {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: auto;
        background: $gray-dark;
        z-index: 999;
        transition: all .3s ease;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// office-detail.vue?493c0309